// extracted by mini-css-extract-plugin
export default {"studentsColumn":"studentsColumn-cGT8j","studentsTopHeaderColumn":"studentsTopHeaderColumn-A_YyX","firstNameHeader":"firstNameHeader-e83GV","nameCell":"nameCell-ZnUKB"};